export const formatTime = (time, timeFormat12hrs = false) => {


    if (!time) {
        console.log("Time parameter is required");

        return;
    }

    
    const [hours, minutes, seconds = "00"] = time.split(":").map(Number);

    if (timeFormat12hrs) {
        const period = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12;
        return `${formattedHours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${period}`;
    } else {
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    }
};


export const formatTimeFormat = (ms, format = "DDd HHh MMm SSs") => {
    const total = Math.max(0, Math.floor(ms / 1000));
    const days    = Math.floor(total / 86400);
    const hours   = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;

    const values = { DD: days, HH: hours, MM: minutes, SS: seconds };

    return format
        .split(" ")
        .filter(segment => {
            const token = segment.match(/DD|HH|MM|SS/)?.[0];
            if (!token) return true;
            if (token === "SS") return true; // always show seconds
            return values[token] > 0;
        })
        .map(segment =>
            segment
                .replace("DD", String(days).padStart(2, "0"))
                .replace("HH", String(hours).padStart(2, "0"))
                .replace("MM", String(minutes).padStart(2, "0"))
                .replace("SS", String(seconds).padStart(2, "0"))
        )
        .join(" ");
};